import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'

import { setCurrentView } from '../../common/app/actions'

let Header = React.createClass({

  render() {
    let anyCheckedOrders = this.props.checkedOrders.length != 0;
    const { t } = this.props;
    const { userName } = this.props.app;

    return (
      <header id="portable-header">
        <div className="content-wrapper">
          <div className="header-title operator-header-title">
            <span>
              <div className="fa fa-bars"></div>
              {" "}{t('ordersList')}
              <span className="header-subtitle">&nbsp;{t('qualityView')}</span>
            </span>
          </div>
          <ul className="actions">
            <li className="user-menu">
              <a style={{ userSelect: 'none' }}>
                <i className="fa fa-user"></i>&nbsp;
                <span className='user-name'>{userName}</span>
              </a>
              <ul>
                <li>
                  <a href="/users/sign_out">{this.props.t('common:signOut')}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </header>
    )
  }

})

let mapStateToProps = (state) => {
  return {
    app: state.app,
    checkedOrders: state.orders.checkedOrders
  }
}

export default connect(mapStateToProps)(translate(['header'])(Header))
